namespace Gamification.Gamification {
    export namespace PermissionKeys {
        export const General = "Gamification:General";
        export const Security = "Gamification:Prodotti";
        export const Risorse = "Gamification:Risorse";
        export const Utenti = "Gamification:Utenti";

        namespace Configurazione {
            export const Delete = "Gamification:Configurazione:Delete";
            export const Modify = "Gamification:Configurazione:Modify";
            export const View = "Gamification:Configurazione:View";
        }
    }
}
